<div class="terms-conditions-popup">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      Manifest Viewer
    </h4>
    <button type="button"
            class="btn-close"
            aria-label="Close"
            (click)="closePopup()"></button>
  </div>

  <div class="modal-body">
    <pre id="json-renderer" [textContent]="jsonText"></pre>
  </div>
</div>
